import React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import "../style/layout.scss";

const termsofservice = () => (
  <Layout>
    <SEO title="利用規約" />
    <div className="about-container">
      <h1>利用規約</h1>
      <p>
        この利用規約（以下，「本規約」といいます。）は，DevpediaCode（以下，「当社」といいます。）がこのウェブサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。ご利用のユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。
      </p>
      <h3>第1条（適用）</h3>
      <ol>
        <li>
          本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
        </li>
        <li>
          当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下，「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。
        </li>
      </ol>
      <h3>第2条（禁止事項）</h3>
      <p>ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。</p>
      <ol>
        <li>法令または公序良俗に違反する行為</li>
        <li>犯罪行為に関連する行為</li>
        <li>当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為</li>
        <li>当社のサービスの運営を妨害するおそれのある行為</li>
        <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
        <li>他のユーザーに成りすます行為</li>
        <li>当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為</li>
        <li>その他，当社が不適切と判断する行為</li>
      </ol>
      <h3>第3条（本サービスの提供の停止等）</h3>
      <ol>
        <li>
          当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
        </li>
        <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
        <li>地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合</li>
        <li>コンピュータまたは通信回線等が事故により停止した場合</li>
        <li>その他，当社が本サービスの提供が困難と判断した場合</li>
      </ol>
      <h3>第4条（著作権）</h3>
      <ol>
        <li>
          当社のウェブサイトに掲載されている記事，画像，ソースコード等のコンテンツの著作権は，当社または正当な権利を有する第三者に帰属します。
        </li>
        <li>
          ユーザーは，当社のコンテンツを個人的な利用の範囲内で参照・引用することができますが，商用目的での無断複製・転載は禁止します。
        </li>
        <li>
          コンテンツを引用する場合は，出典としてDevpediaCodeの名称およびURLを明記してください。
        </li>
      </ol>
      <h3>第5条（免責事項）</h3>
      <ol>
        <li>
          当社は，本サービスに事実上または法律上の瑕疵（安全性，信頼性，正確性，完全性，有効性，特定の目的への適合性，セキュリティなどに関する欠陥，エラーやバグ，権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
        </li>
        <li>
          当社は，本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。
        </li>
        <li>
          当社のウェブサイトに掲載されているソースコードや技術情報は，ユーザーの責任においてご利用ください。
        </li>
      </ol>
      <h3>第6条（サービス内容の変更等）</h3>
      <p>
        当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。
      </p>
      <h3>第7条（利用規約の変更）</h3>
      <p>
        当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。変更後の利用規約は，当社ウェブサイトに掲載したときから効力を生じるものとします。
      </p>
      <h3>第8条（準拠法・裁判管轄）</h3>
      <ol>
        <li>本規約の解釈にあたっては，日本法を準拠法とします。</li>
        <li>
          本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
        </li>
      </ol>
      <h3>お問い合わせ</h3>
      <p>本規約に関するお問い合わせは，下記の窓口までお願いいたします。</p>
      <p>
        <Link to={"/contact"}>お問い合わせ</Link>
      </p>
    </div>
  </Layout>
);

export default termsofservice;
